<template>
 <v-card>
    <v-card-title> <h3 class="headline mb-0">Recycle Bin</h3>
      <v-btn text icon color="grey lighten-1" @click="refreshDeletedUsers"><v-icon>fas fa-sync</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchDeleted"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="deletedUsers"
      :search="searchDeleted"
      v-model="selected"
      show-select
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.name="{item}">
        <td>
          {{ item.name }}
          &nbsp;
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-icon small v-if="item.collectionAgent" v-on="on">fal fa-folders</v-icon>
            </template>
            <span>Collection Agent</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:item.roles="{item}">
        <td>{{ formatRoles(item.roles) }}</td>
      </template>
      <template v-slot:item.updatedDate="{item}">
        <td>{{ formatDateTime(item.updatedDate) }}</td>
      </template>
      <template v-slot:item.actions="{item}">
        <td class="actions">
             <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn text icon @click="undelete(item.id)" v-on="on"
                    style="height: 0px; width: 0px; padding-right:2px;"
                  >
                    <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash-restore</v-icon>
                  </v-btn>
                </template>
                <span>Restore</span>
            </v-tooltip>
        </td>
      </template>
    </v-data-table>
            <v-card-actions>
                <v-btn @click="undeleteSelected" :disabled="!selected.length">Restore Selected</v-btn>
          </v-card-actions>
        </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            selected: [],
            searchDeleted: '',
            loading: false,
            deletedUsers: [],
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Email', align: 'left', sortable: true, value: 'email'},
                {text: 'Phone', align: 'left', sortable: true, value: 'phone'},
                {text: 'Timezone', align: 'left', sortable: true, value: 'timeZone'},
                {text: 'Login', align: 'left', sortable: true, value: 'login'},
                {text: 'Roles', align: 'left', sortable: false, value: 'roles'},
                {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
            ],
            pagination : {'sortBy': ['updatedDate'], 'sortDesc': [true]}
        }
    },
    async created() {
        this.loading = true
        this.deletedUsers = await this.$store.dispatch('user/getDeletedUsers')
        this.loading = false
    },
    methods: {
        async undelete(userId) {
            await this.$store.dispatch('user/unDeleteUser', userId)
            this.$emit('userUnDeleted', userId)
            await this.refreshDeletedUsers()
        },
        async refreshDeletedUsers() {
            this.loading = true
            this.deletedUsers = await this.$store.dispatch('user/getDeletedUsers')
            this.loading = false
        },
        formatRoles(roles) {
            return _.map(roles, 'name').join(', ')
        },
        formatDateTime(val) {
            return moment(val).format('MM/DD/YYYY, h:mm:ss a')
        },
        async undeleteSelected() {
            await this.$store.dispatch('user/unDeleteMultipleUsers', this.selected)
            this.$emit('usersUnDeleted', this.selected)
            this.selected = []
            await this.refreshDeletedUsers()
        }
    }
}
</script>
